export default function CsharpComments() {
  return (
    <h2>Csharp Comments</h2>
  );
}
